'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = require('react-redux');

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _recompose = require('recompose');

var _forms = require('./forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var onlyChangeableProps = R.pick(['initialValue', 'required']);

var withoutPrivateProps = R.omit(['component', 'initialValue', 'store', 'storeSubscription']);

function mapStateToProps(state, props) {
  return {
    focused: _forms.selectors.isFocused(state.forms, props),
    errors: _forms.selectors.errors(state.forms, props),
    pristine: _forms.selectors.isPristine(state.forms, props),
    required: _forms.selectors.isRequired(state.forms, props),
    status: _forms.selectors.status(state.forms, props),
    value: _forms.selectors.value(state.forms, props),
    visited: _forms.selectors.isVisited(state.forms, props)
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    onBlur: function onBlur(event) {
      if (props.onBlur) {
        props.onBlur(event);
      }

      dispatch(_forms.actions.blur(props.form, props.field));
      dispatch(_forms.actions.visit(props.form, props.field));
    },
    onChange: function onChange(value) {
      dispatch(_forms.actions.validate(props.form, props.field, { status: 'processing' }));

      if (props.onChange) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('DEPRECATED', 'passing onChange to Field component is deprecated and will be removed');
        }

        props.onChange(value);
      }

      dispatch(_forms.actions.changeValue(props.form, props.field, value));
    },
    onFieldRegister: function onFieldRegister(required, initialValue, value) {
      return dispatch(_forms.actions.register(props.form, props.field, {
        group: props.group,
        initialValue: initialValue,
        required: required,
        value: value
      }));
    },
    onFocus: function onFocus(event) {
      if (props.onFocus) {
        props.onFocus(event);
      }

      dispatch(_forms.actions.focus(props.form, props.field));
    },
    onValidate: function onValidate(value) {
      if (props.required && (value == null || value.length === 0)) {
        return dispatch(_forms.actions.validate(props.form, props.field, { status: false }));
      }

      var isPristine = value === props.initialValue;

      if ((!value || !isPristine) && props.validator) {
        if (typeof props.validator === 'function') {
          var validateAction = props.validator(props.form, props.field, value);

          if (validateAction) {
            return dispatch(validateAction);
          }
        }

        if (R.is(Array, props.validator)) {
          var _validateAction = R.reduceWhile(R.isNil, function (action, validator) {
            return validator(props.form, props.field, value);
          }, undefined, props.validator);

          if (_validateAction) {
            return dispatch(_validateAction);
          }
        }
      }

      dispatch(_forms.actions.validate(props.form, props.field, { status: true }));
    }
  };
}

var connectOptions = { areStatePropsEqual: R.equals };

var withFormName = (0, _recompose.compose)((0, _recompose.getContext)({ form: _propTypes2.default.string.isRequired }), (0, _recompose.renameProp)('name', 'field'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, connectOptions), (0, _recompose.renameProp)('field', 'name'));

var Field = function (_Component) {
  _inherits(Field, _Component);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
  }

  _createClass(Field, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.onFieldRegister(this.props.required, this.props.initialValue, this.props.value);

      if (this.props.value || this.props.initialValue) {
        this.props.onValidate(this.props.value || this.props.initialValue);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isChangedChangeable = R.equals(onlyChangeableProps(this.props), onlyChangeableProps(nextProps));

      if (!isChangedChangeable) {
        this.props.onFieldRegister(nextProps.required, nextProps.initialValue, nextProps.value);
        this.props.onValidate(nextProps.value || nextProps.initialValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = R.merge(this.props, {
        onBlur: function onBlur(event) {
          _this2.props.onBlur(event);
        },
        onChange: R.pipe(R.when(R.pathSatisfies(R.is(String), ['target', 'value']), R.path(['target', 'value'])), function (val) {
          var value = _this2.props.normalize(val);

          _this2.props.onChange(value);
          _this2.props.onValidate(value);
        })
      });

      return (0, _react.createElement)(this.props.component, withoutPrivateProps(props));
    }
  }]);

  return Field;
}(_react.Component);

Field.defaultProps = { normalize: R.identity };

Field.propTypes = {
  component: _propTypes2.default.func.isRequired,
  focused: _propTypes2.default.bool.isRequired,
  errors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  name: _propTypes2.default.string.isRequired,
  pristine: _propTypes2.default.bool.isRequired,
  required: _propTypes2.default.bool,
  normalize: _propTypes2.default.func,
  status: _propTypes2.default.string,
  validator: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
  visited: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func.isRequired
};

exports.default = withFormName(Field);